import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import FilterToggle from "../../atoms/FilterToggle";
import Fuse from "fuse.js";
import { useState } from "react";
import { getInmobiliaria } from "../../../utils/getInmobiliaria";

const QyRAllFilter = ({ filters, setFilters, inmuebles }) => {
    const [selectedInmuebles, setSelectedInmuebles] = useState([]);

    const options = inmuebles?.map(im => ({
        value: im.id,
        label: `${im?.name} - ${getInmobiliaria(im.real_estate)}`,
    }));
    const handleChange = (e) => {
        setFilters(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleStatusChange = (selectedOption) => {
        setFilters(prev => ({
            ...prev,
            status: selectedOption ? selectedOption.value : "",
        }));
    };

    const handleIncidentRangeChange = (dates) => {
        const [start, end] = dates;
        setFilters(prev => ({
            ...prev,
            incidentRange: { start, end }
        }));
    };

    const handleServiceRangeChange = (dates) => {
        const [start, end] = dates;
        setFilters(prev => ({
            ...prev,
            serviceRange: { start, end }
        }));
    };

    const handleReset = () => {
        setFilters({
            description: "",
            incidentRange: { start: null, end: null },
            serviceRange: { start: null, end: null },
            status: "",
            inmuebles: [],
        });
        setSelectedInmuebles([]);
    };

    const statusOptions = [
        { value: "", label: "Todos" },
        { value: "Pendiente", label: "Pendiente" },
        { value: "Resuelto", label: "Resuelto" },
    ];

    const selectedStatus = statusOptions.find(option => option.value === filters.status);

    return (
        <FilterToggle>
            <div className="w-full flex flex-col gap-2">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                    <input
                        type="text"
                        placeholder="Buscar por queja o reporte"
                        name="description"
                        value={filters.description}
                        onChange={handleChange}
                        className="border p-2 rounded w-full"
                    />
                    <div className="w-full">
                        <DatePicker
                            selectsRange
                            startDate={filters.incidentRange.start}
                            endDate={filters.incidentRange.end}
                            onChange={handleIncidentRangeChange}
                            placeholderText="Rango de Reporte"
                            className="border p-2 rounded w-full min-w-0"
                            isClearable
                            dateFormat="dd/MM/yy"
                        />
                    </div>
                    <div className="w-full">
                        <DatePicker
                            selectsRange
                            startDate={filters.serviceRange.start}
                            endDate={filters.serviceRange.end}
                            onChange={handleServiceRangeChange}
                            placeholderText="Rango de Servicio"
                            className="border p-2 rounded w-full min-w-0"
                            isClearable
                            dateFormat="dd/MM/yy"
                        />
                    </div>
                    <Select
                        name="status"
                        options={statusOptions}
                        value={selectedStatus}
                        onChange={handleStatusChange}
                        className="w-full"
                        isClearable
                    />
                    <div className="col-span-2">
                        <Select
                            isMulti
                            name="inmuebles"
                            value={selectedInmuebles}
                            onChange={(selected) => {
                                setSelectedInmuebles(selected || []);
                                setFilters(prev => ({
                                    ...prev,
                                    inmuebles: selected?.map(sel => sel.value) || [],
                                }));
                            }}
                            options={options}
                            placeholder="Inmueble(s)..."
                            className="w-full"
                            filterOption={createFuseFilter(options, ["label"])}
                        />
                    </div>
                </div>

                <div className="flex justify-end">
                    <button onClick={handleReset} className="text-gray-500 text-xs p-1">
                        Limpiar filtros
                    </button>
                </div>
            </div>
        </FilterToggle>
    );
};

export default QyRAllFilter;


const createFuseFilter = (optionsList, keys) => {
    const fuse = new Fuse(optionsList, {
        keys,
        threshold: 0.3,
        ignoreLocation: true,
        includeScore: false,
        useExtendedSearch: true,
    });

    return (candidate, input) => {
        if (!input) return true;
        const results = fuse.search(input);
        return results.some(res => res.item.value === candidate.value);
    };
};
